import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../../../../../theme';


const Node = styled.div`
  position: relative;
  overflow: hidden;
  min-width: 100%;
  padding-left: 45px;
  border-bottom: 1px solid ${theme.colors.light};
  color: ${theme.colors.medium};
  background: ${theme.colors.white};
  white-space: nowrap;
  text-align: left;
  font-size: ${theme.fontSizes.medium};
  @media print {
    padding-left: 0;
  }
  
`;

const NodeContent = styled.div`
  position: absolute;
  top: 10px;
  bottom: 10px;
  width: calc(100% - 90px);
  display: flex;
  align-items: center;
`;

class PermissionThemeTreeNodeRenderer extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.bound = {
      handleMouseOver: this.handleMouseOver.bind(this),
      handleMouseLeave: this.handleMouseLeave.bind(this),
    };
  }

  handleMouseOver() {
    const { highlight } = this.state;
    if (!highlight) {
      this.setState({ highlight: true });
    }
  }

  handleMouseLeave() {
    this.setState({ highlight: false });
  }

  render() {
    const {
      children,
      swapFrom,
      swapLength,
      swapDepth,
      scaffoldBlockPxWidth,
      lowerSiblingCounts,
      connectDropTarget,
      isOver,
      draggedNode,
      canDrop,
      treeIndex,
      getPrevRow, // Delete from otherProps
      node, // Delete from otherProps
      path, // Delete from otherProps
      ...otherProps
    } = this.props;
    // Construct the scaffold representing the structure of the tree
    const scaffoldBlockCount = lowerSiblingCounts.length - 1;
    // const isValidDrop = canDrop && !isOver;
    let dropType;
    if (canDrop && !isOver) {
      dropType = 'validDrop';
    } else if (!canDrop && isOver) {
      dropType = 'invalidDrop';
    }

    const nodeContent = (
      <NodeContent style={{ paddingLeft: scaffoldBlockPxWidth * scaffoldBlockCount }}>
        {Children.map(children, (child) => cloneElement(child, {
          isOver,
          canDrop,
          draggedNode,
        }))}
      </NodeContent>
    );


    return (
      <Node
        dropType={dropType}
        onMouseOver={this.bound.handleMouseOver}
        onMouseLeave={this.bound.handleMouseLeave}
        {...otherProps}
        onFocus={() => {}}
        ref={(instance) => connectDropTarget(instance)}
        canDrop={canDrop}
        isOver={isOver}
      >
        {nodeContent}
      </Node>
    );
  }
}

PermissionThemeTreeNodeRenderer.defaultProps = {
  swapFrom: null,
  swapDepth: null,
  swapLength: null,
  canDrop: false,
  draggedNode: null,
};

PermissionThemeTreeNodeRenderer.propTypes = {
  treeIndex: PropTypes.number.isRequired,
  swapFrom: PropTypes.number,
  swapDepth: PropTypes.number,
  swapLength: PropTypes.number,
  scaffoldBlockPxWidth: PropTypes.number.isRequired,
  lowerSiblingCounts: PropTypes.arrayOf(PropTypes.number).isRequired,

  children: PropTypes.node.isRequired,

  // Drop target
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool,
  draggedNode: PropTypes.shape({}),

  // used in dndManager
  getPrevRow: PropTypes.func.isRequired,
  node: PropTypes.shape({}).isRequired,
  path: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
};

export default PermissionThemeTreeNodeRenderer;
